<template>
  <BaseCard class="h-full">
    <div class="p-5 h-full flex flex-col">
      <div class="flex items-start justify-between gap-3 mb-4">
        <div class="min-w-0">
          <div class="font-semibold text-sm text-gray-dark">
            {{ title }}
          </div>
          <div v-if="subtitle" class="text-[11px] text-slate-500 mt-0.5">
            {{ subtitle }}
          </div>
        </div>
        <slot name="legend" />
      </div>

      <div class="flex-1">
        <div
          v-if="pending"
          class="h-full min-h-[150px] flex flex-col items-center justify-center text-center gap-2 rounded-xl border border-dashed border-slate-200 py-6 px-4"
        >
          <Icon name="mdi-chart-timeline-variant" :size="26" color="#cbd5e1" />
          <div class="text-xs font-medium text-slate-400">
            Bientôt disponible
          </div>
          <div v-if="pendingHint" class="text-[11px] text-slate-400 max-w-[240px]">
            {{ pendingHint }}
          </div>
        </div>
        <slot v-else />
      </div>
    </div>
  </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "@/core/components/base/BaseCard.vue";
import Icon from "@/core/components/icon/Icon.vue";

withDefaults(defineProps<{
    /** Panel title. */
    title: string;
    /** Optional panel sub-title. */
    subtitle?: string | null;
    /** When true, renders a "coming soon" empty state instead of the slot. */
    pending?: boolean;
    /** Optional hint explaining why the panel is pending. */
    pendingHint?: string | null;
}>(), {
    subtitle: null,
    pending: false,
    pendingHint: null
});
</script>
